import React, { useState, useCallback, useEffect } from 'react';
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import FilterWidget from './index';
import UnifiedModal from '../UnifiedModal';

const FilterModal = ({ dir, data = [], activeFilters, onChange, onClear, isAirport, locationSlug, pickupDate, dropoffDate, buttonLabel, buttonClassName, buttonVariant }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = useCallback(() => setShowModal(false), []);

  // Prevent body scroll when modal is open on mobile
  useEffect(() => {
    if (showModal && isMobile) {
      document.body.classList.add('fullscreen-modal-active');
    } else {
      document.body.classList.remove('fullscreen-modal-active');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('fullscreen-modal-active');
    };
  }, [showModal]);

  const title = (
    <>
      <svg className='mx-2' height="24" width="24" fill='#007bff' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" />
      </svg>
      {t('filter')}
    </>
  );

  return (
    <>
      <style>
        {`
          .rainbow-svg {
            animation: brand-colors 3s ease-in-out infinite;
          }
          @keyframes brand-colors {
            0% { fill: #ffb3ba; }
            14% { fill: #ffdfba; }
            28% { fill: #ffffba; }
            42% { fill: #baffba; }
            57% { fill: #bae1ff; }
            71% { fill: #d1baff; }
            85% { fill: #ffb3d9; }
            100% { fill: #ffb3ba; }
          }
        `}
      </style>
      <Button variant={buttonVariant || "primary"} onClick={() => setShowModal(true)} className={buttonClassName || "mb-3 w-100"}>
        <svg className='mx-2 rainbow-svg' height="24" width="24" fill='#ffffffff' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" />
        </svg>
        {buttonLabel || t('filter')}
      </Button>
      <UnifiedModal
        show={showModal}
        onHide={handleCloseModal}
        title={title}
        dir={dir}
        dialogClassName="modal-dialog-scrollable"
      >
        <FilterWidget
          dir={dir}
          data={data}
          activeFilters={activeFilters}
          onChange={onChange}
          onClear={onClear}
          isAirport={isAirport}
          locationSlug={locationSlug}
          pickupDate={pickupDate}
          dropoffDate={dropoffDate}
        />
      </UnifiedModal>
    </>
  );
};

export default FilterModal;